import { useDispatch, useSelector } from "react-redux";

import React, { useEffect, useState, useRef } from 'react';

import { MapContainer, TileLayer, Marker, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import axios from 'axios';

import { meterInfoActions } from '../store/meterInfo';

import './map.css';

const ParkingMap = ({ isWideScreen }) => {

    const meterInfo = useSelector(state => state.meterInfo);

    const icon = L.icon({ iconUrl: "pin.png", iconSize: [30, 40] });

    const my_location_icon = L.icon({ iconUrl: "my_location_pin.png", iconSize: [20, 20] });

    const [map, setMap] = useState(null);

    const [bbox, setBbox] = useState(null);

    const [parkingMeters, setParkingMeters] = useState([]);

    const dispatch = useDispatch();

    const myLocationRef = useRef();

    useEffect(() => {
        if (!map) return;

        const bounds = map.target.getBounds();
        setBbox({
            lat1: bounds._southWest.lat,
            lon1: bounds._southWest.lng,
            lat2: bounds._northEast.lat,
            lon2: bounds._northEast.lng
        });

        map.target.on("moveend", function () {
            const newBounds = map.target.getBounds();
            setBbox({
                lat1: newBounds._southWest.lat,
                lon1: newBounds._southWest.lng,
                lat2: newBounds._northEast.lat,
                lon2: newBounds._northEast.lng
            });
        });


    }, [map]);

    useEffect(() => {
        if (bbox) {
            const getMeterInfo = () => {
                axios.get('https://opendata.vancouver.ca/api/explore/v2.1/catalog/datasets/parking-meters/records?where=in_bbox(geo_point_2d, '
                    + bbox.lat1 + ", "
                    + bbox.lon1 + ", "
                    + bbox.lat2 + ", "
                    + bbox.lon2 + ")&limit=100")
                    .then((response) => {
                        setParkingMeters(response.data.results);
                    })
                    .catch((error) => {

                    });
            }
            getMeterInfo();
        }
    }, [bbox]);

    const saveMeterInfo = (parkingMeter) => {
        // 스토어 meter 데이터 저장
        dispatch(meterInfoActions.save({
            meterId: parkingMeter.meter_id,
            meterHead: parkingMeter.meter_head,
            rate9am6pm: parkingMeter.rate_9am_6pm,
            rate6pm10pm: parkingMeter.rate_6pm_10pm,
            flatRate: parkingMeter.flat_rate,
            timeLimit9am6pm: parkingMeter.time_limit_9am_6pm,
            timeLimit6pm10pm: parkingMeter.time_limit_6pm_10pm,
            timeLimitWeekend9am6pm: parkingMeter.time_limit_weekend_9am_6pm,
            timeLimitWeekend6pm10pm: parkingMeter.time_limit_weekend_6pm_10pm,
            creditCard: parkingMeter.credit_card,
            payPhone: parkingMeter.mobile_payment_number
        }));

        // 스토어 informationBox 설정
        dispatch(meterInfoActions.setInformationBox(true));

        // 맵 center position 이동
        if (!isWideScreen) {
            // 세로 모드
            map.target.flyTo([parkingMeter.geo_point_2d.lat - 0.0007, parkingMeter.geo_point_2d.lon], 18);
        } else {
            // 가로 모드
            map.target.flyTo([parkingMeter.geo_point_2d.lat, parkingMeter.geo_point_2d.lon + 0.0009], 18);
        }
    }

    useEffect(() => {
        if (isWideScreen) {
            if (meterInfo.informationBox && meterInfo.meterId) {
                myLocationRef.current.style.left = "30%";
                return;
            }
            myLocationRef.current.style.left = "50%";
        } else {
            myLocationRef.current.style.left = "50%";
        }
    }, [isWideScreen, meterInfo.informationBox, meterInfo.meterId])

    const getNowRatePerHour = (data) => {
        if (data.flat_rate) {
            return data.flat_rate;
        }

        const hour = new Date().getHours();

        // 9am - 6pm
        if (hour >= 9 && hour < 18) {
            return data.rate_9am_6pm || "Please check the meter";
        }
        // 6pm - 10pm
        if (hour >= 18 && hour < 22) {
            return data.rate_6pm_10pm || "Please check the meter";
        }

        return "Please check the meter";
    }

    const [myLocation, setMyLocation] = useState(null);
    const findMyLocation = () => {
        map.target.locate().on("locationfound", function (e) {
            map.target.flyTo(e.latlng, 18);
            setMyLocation(<Marker className="my-location-icon" position={[e.latlng.lat, e.latlng.lng]} icon={my_location_icon}></Marker>);
        });

    }

    return (
        <div className="map">
            <button ref={myLocationRef} className="my-location" onClick={findMyLocation}>
                <img className="my-location-icon" alt="my-lcation-icon" src={process.env.PUBLIC_URL + '/my_location.png'} />
                <div>Your Location</div>
            </button>
            <MapContainer center={[49.2829, -123.1254]} zoom={14} scrollWheelZoom={true} whenReady={setMap}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {parkingMeters.map((parkingMeter, index) => {
                    return (
                        <Marker
                            key={index}
                            position={[parkingMeter.geo_point_2d.lat, parkingMeter.geo_point_2d.lon]}
                            icon={icon}
                            eventHandlers={{
                                click: () => {
                                    saveMeterInfo(parkingMeter);
                                },
                            }}>
                            <Tooltip
                                direction="top"
                                style={{ background: "white" }}
                                permanent>{getNowRatePerHour(parkingMeter)}</Tooltip>
                        </Marker>
                    );
                })}
                {myLocation}
            </MapContainer>
        </div>
    );
};

export default ParkingMap;
